import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import calenderIcon from "../../assets/images/top-calender-icon.svg";
import buldingIcon from "../../assets/images/top-building-icon.svg";
import { InnModalPopup } from "../innModalPopup";
import { InnLoader } from "../innLoader";
import {
    GetDecodedString,
    GetEncodedString,
    GetPropertyDetails,
    GetReservationData
} from "../../services/selfCheckinService";
import { useDispatch, useSelector } from "react-redux";
import {
    currentUser,
    encodedStringData,
    propertyDetails,
    setAllServiceAndCharges,
    setCurrentUser,
    setHomeNavigate,
    setPropertyDetails,
    setReservationData,
    setRoomCatgDataWithMeal
} from "../../reducer/selfCheckinSlice";
import moment from "moment";

function HomePage() {

    //#region State Variable  
    const [showSeeBreakUp, setShowSeeBreakUp] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const [showCalenderData, setShowCalenderData] = useState(false);
    const [reservationHeaderData, setReservationHeaderData] = useState({});
    const [reservationDetails, setReservationDetails] = useState([]);
    const [subTotalAmount, setSubTotalAmount] = useState();
    const [allCharges, setAllCharges] = useState([]);
    const [finalTotal, setFinalTotal] = useState();
    //#endregion

    //#region Local Variable
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const propertyDetail = useSelector(propertyDetails);
    const currUser = useSelector(currentUser);
    const wait = timeOut => {
        return new Promise(resolve => setTimeout(resolve, timeOut));
    }
    //#endregion

    //#region api Calling
    const FillPropertyDetail = () => {
        GetPropertyDetails(currUser?.ClientID, currUser?.PropertyID).then((d) => {
            let tempData = JSON.parse(JSON.stringify(d.data))
            dispatch(setPropertyDetails(tempData))
            wait(2500).then(() => setIsActive(false))
        }).catch((ex) => {
            wait(1000).then(() => setIsActive(false))
            console.log('Property detail exception', ex);
        })
    }
    const fillGuestDetail = () => {
        GetReservationData(currUser?.ClientID, currUser?.PropertyID, currUser?.BookingNo).then((d) => {
            setReservationHeaderData(d.data.reservationHeaderData);
            setReservationDetails(d.data.reservationDetailData)
            dispatch(setRoomCatgDataWithMeal(d.data.reservationDetailData));
            dispatch(setReservationData(d.data.reservationHeaderData));
            setAllCharges(d.data.reservationTaxData);
            dispatch(setAllServiceAndCharges(d.data.reservationTaxData));
        }).catch((ex) => {
            wait(1000).then(() => setIsActive(false))
            console.log('Reservation detail exception', ex);
            // navigate('/Unauthorised')
        });
    }
    //#endregion

    //#region Encode Decode api call
    const getDecodeString = (str) => {
        // console.log(`Current path is ${pathname} with search ${search} and params`, params);
        GetDecodedString(str).then((d) => {
            // console.log("Decode String :: ", d.data);
            var obj = d.data;
            var temp = obj.split("_");
            // console.log("After Split String :: ", temp);
            if (temp.length !== 0) {
                let arr = {
                    ClientID: temp[0],
                    PropertyID: temp[1],
                    BookingNo: temp[2]
                }
                dispatch(setCurrentUser(arr))
                FillPropertyDetail(temp);
                fillGuestDetail(temp);
            }
        }).catch((ex) => {
            console.log("Decode Error :: ", ex)
        });
    }
    //#endregion

    //#region UseEffect 
    useEffect(() => {
       
        fillGuestDetail()
        FillPropertyDetail();
        // if (propertyDetail === undefined) {
        //     navigate("/Unauthorised")
        // }
        // getDecodeString(encodedStringObj);
    }, [])
    useEffect(() => {
        if (reservationHeaderData?.IsAnyBookingCheckin === true) {
            navigate('/restrict');
        }
    }, [reservationHeaderData])
    useEffect(() => {
        let total = 0;
        reservationDetails.forEach((x) => {
            total += x?.TotalTarrif
            setSubTotalAmount(total) // total and sub total calculated
        });
        let finalAmt = 0;
        allCharges.forEach((x) => {
            finalAmt += x?.Tax;
        })
        let grossAmt = finalAmt + subTotalAmount
        setFinalTotal(grossAmt)
        // console.log(subTotalAmount);
    }, [subTotalAmount, allCharges])
    //#endregion

    return (
        <div>
            <InnLoader className={isActive ? "active" : null}></InnLoader>
            <div className="wrapper">
                <div className="login-top-img">
                    <img src="" />
                    <div className="login-img-overlay"></div>
                </div>
                <div className="login-top-bg">
                    <div className="top-icon">
                        <div>
                            <img
                                onClick={() => {
                                    setIsActive(true)
                                    setShowCalenderData(!showCalenderData)
                                    wait(1000).then(() => setIsActive(false))
                                }}
                                src={calenderIcon}
                            />
                        </div>
                        <Link to="/HomeInfo">
                            <div style={{ marginLeft: 10 }}>
                                <img src={buldingIcon} onClick={() => { dispatch(setHomeNavigate("FromHomePage")) }} />
                            </div>
                        </Link>
                    </div>
                    {/* <div className="reg-hdng">Hi MUKESH MAKWANA !</div> */}
                    <div className="reg-hdng">{'Hi ' + reservationHeaderData?.GuestName + ' !'}</div>
                    <div className="reg-sub-hdng">
                        Welcome to {propertyDetail?.Name} - {propertyDetail?.CityName}
                    </div>
                </div>
                <div className="reg-white-bg">
                    <div className="reg-note p-tp40 text-center">
                        {" "}
                        Please verify your Stay Details below and proceed for Self Check-in{" "}
                    </div>
                    <div className="reg-detail text-left">
                        <h3>{reservationHeaderData?.GuestName}</h3>
                    </div>
                    <div className="reg-detail m-btm20">
                        <div className="wdth50 bdr-rgt">
                            {/* <p>03 Jun - 04 Jun </p> */}
                            <p>{moment(new Date(reservationHeaderData?.Arrival_Date)).format("DD MMM")} - {moment(new Date(reservationHeaderData?.Departure_Date)).format("DD MMM")} </p>
                            <p>{reservationHeaderData?.No_Of_Nights} Nights</p>
                        </div>
                        <div className="wdth50">
                            <p className="p-lt15">Booking No: {reservationHeaderData?.Booking_No}</p>
                            <p className="p-lt15">{reservationHeaderData?.No_Of_Rooms} Room {reservationHeaderData?.Adult} Adults</p>
                        </div>
                    </div>
                    <div className="light-red-bg bdr-tp">
                        {
                            reservationDetails.map((x) => {
                                return (
                                    <div className="room-detail bdr-tp" key={x.BookingSer_No}>
                                        <div className="room-num">
                                            {/* No. of Rooms */}
                                            Room <br />{x?.No_Of_Rooms}
                                        </div>
                                        <div>
                                            <div className="room-facylity">
                                                <div>
                                                    {/* RoomCatg */}
                                                    <p>{x?.RoomCatg}</p>
                                                </div>
                                                <div>
                                                    <p>{x?.Adult} Adults</p>
                                                </div>
                                            </div>
                                            <div className="room-facylity">
                                                {
                                                    x?.InclSerName === "" ?
                                                        <></>
                                                        :
                                                        <h5>Meal Plan: {x?.InclSerName} Included</h5>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <div className="reg-detail m-tp30">
                    <div className="room-rate-hdg bdr-rgt">
                        <div>Total Booking Value</div>
                        <div className="total-rate"> {reservationHeaderData?.TotalBookingValue === 0 ? "0.00" : parseFloat(reservationHeaderData?.TotalBookingValue).toFixed(2)} </div>
                    </div>
                    <button
                        onClick={() => {
                            setIsActive(true)
                            setShowSeeBreakUp(!showSeeBreakUp)
                            wait(1000).then(() => setIsActive(false))
                        }}
                        className="primary-btn m-lt15"
                    >
                        {" "}
                        SEE BREAKUP{" "}
                    </button>
                </div>
                <Link to="/Registration">
                    <div className="reg-detail m-tp20">
                        <button className="drk-blue-btn"> Start Registration </button>
                    </div>
                </Link>

                <div className="reg-note bottom-content text-center">
                    <p>
                        Something wrong with your reservation? Please contact us so we can
                        sort it out
                    </p>
                </div>
            </div>

            <div className="overlay">
                <div className="overlay-background"></div>
                {/* <div className="overlay-content"><span className="spinner"></span>&nbsp;&nbsp;&nbsp;Loading
        </div> */}
            </div>
            <div className="hidden">
                <div className="loader-overlay"></div>
            </div>

            {showSeeBreakUp ? (
                <InnModalPopup Onclose={() => setShowSeeBreakUp(false)}>
                    <div className="modal-content x-small-popup">
                        <div
                            id="myModal3"
                            tabindex="-1"
                            role="dialog"
                            aria-labelledby="myModalLabel3"
                            className="model-popup"
                        >
                            <div role="document">
                                <div className="modal-header">
                                    <h4 className="modal-title">BREAKUP</h4>
                                </div>
                                <div className="modal-body scroll-overlay">
                                    <div>
                                        {
                                            reservationDetails.map((x) => {
                                                return (
                                                    <div className="popup-flex">
                                                        <div className="wdth60 popup-brk-text">
                                                            {x?.No_Of_Rooms} {x?.RoomCatg} <br />
                                                            {
                                                                x?.InclSerName === "" ?
                                                                    <span>
                                                                        {x?.Adult} Adult {x?.Child} Child
                                                                    </span>
                                                                    :
                                                                    <span>
                                                                        With {x?.InclSerName} - {x?.Adult} Adult {x?.Child} Child
                                                                    </span>
                                                            }

                                                        </div>
                                                        <div className="wdth40 popup-brk-fgr">{parseFloat(x?.TotalTarrif).toFixed(2)}</div>
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>
                                    <div className="popup-flex">
                                        <div className="wdth60 popup-brk-text">Sub Total</div>
                                        <div className="wdth40 popup-brk-fgr">{parseFloat(subTotalAmount).toFixed(2)}</div>
                                    </div>
                                    <div className="popup-flex">
                                        {
                                            allCharges && allCharges.map((x) => {
                                                return (
                                                    <>
                                                        <div className="wdth60 popup-brk-text m-tp5">{x?.ChargeName}</div>
                                                        <div className="wdth40 popup-brk-fgr m-tp5">{x?.Tax}</div>
                                                    </>
                                                )
                                            })
                                        }
                                    </div>
                                    {/* <div className="popup-flex">
                                        <div className="wdth60 popup-brk-text m-tp5">
                                            Add: Service Charge
                                        </div>
                                        <div className="wdth40 popup-brk-fgr m-tp5">500</div>
                                    </div>
                                    <div className="popup-flex">
                                        <div className="wdth60 popup-brk-text m-tp5">Add: SGST</div>
                                        <div className="wdth40 popup-brk-fgr m-tp5">{"00"}</div>
                                    </div> */}
                                    <div className="popup-flex-bdr-btm"></div>
                                    <div className="popup-flex">
                                        <div className="wdth60 popup-brk-text-total">
                                            Final Total
                                        </div>
                                        <div className="wdth40 popup-brk-fgr-total">{parseFloat(finalTotal).toFixed(2)}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </InnModalPopup>
            ) : null}

            {showCalenderData ? (
                <InnModalPopup Onclose={() => setShowCalenderData(false)}>
                    <div class="modal-content x-small-popup">
                        <div
                            id="myModal3"
                            tabindex="-1"
                            role="dialog"
                            aria-labelledby="myModalLabel3"
                            class="model-popup"
                        >
                            <div role="document">
                                <div class="reg-detail text-left">
                                    <h2>{reservationHeaderData?.GuestName}</h2>
                                </div>
                                <div class="reg-detail p-btm30">
                                    <div class="wdth50 bdr-rgt">
                                        <p>{moment(new Date(reservationHeaderData?.Arrival_Date)).format("DD MMM")} - {moment(new Date(reservationHeaderData?.Departure_Date)).format("DD MMM")}</p>
                                        <p>{reservationHeaderData?.No_Of_Nights} Nights</p>
                                    </div>
                                    <div class="wdth50">
                                        <p class="text-right">Booking No: {reservationHeaderData?.Booking_No}</p>
                                        <p class="text-right">{reservationHeaderData?.No_Of_Rooms} Room {reservationHeaderData?.Adult} Adults</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </InnModalPopup>
            ) : null}
        </div>
    );
}

export default HomePage;
